// frontend/src/pages/SystemStatusPage.jsx
import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, CheckCircle2, Activity, Clock, Shield } from "lucide-react";

export default function SystemStatusPage() {
  const systems = [
    { name: "Painel Principal (App)", status: "Operacional", time: "99.9% Uptime" },
    { name: "API OdontoAssist", status: "Operacional", time: "100% Uptime" },
    { name: "Banco de Dados & Backups", status: "Operacional", time: "Verificado hoje" },
    { name: "Motor de Inteligência Artificial", status: "Operacional", time: "99.8% Uptime" },
    { name: "Serviço de Faturamento (Asaas)", status: "Operacional", time: "100% Integrado" }
  ];

  return (
    <div className="min-h-screen bg-slate-50 text-gray-900 font-sans">
      <header className="border-b bg-white sticky top-0 z-40">
        <div className="max-w-5xl mx-auto px-4 py-4 flex justify-between items-center">
          <Link to="/">
            <img src="/marketing/logo_official.png" className="h-14" alt="OdontoAssist AI Logo" />
          </Link>
          <Link to="/" className="text-indigo-600 hover:text-indigo-800 transition-colors font-semibold flex items-center gap-2">
            <ArrowLeft size={16} /> Voltar para o início
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-16">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-black text-gray-900 mb-6">Status do Sistema</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Acompanhe a disponibilidade e o desempenho dos serviços da plataforma OdontoAssist AI em tempo real.
          </p>
        </div>

        <div className="bg-white rounded-3xl p-8 border border-gray-100 shadow-xl shadow-indigo-900/5 mb-10">
          <div className="flex flex-col md:flex-row items-center gap-6 pb-8 border-b border-gray-100">
            <div className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center text-green-500 shrink-0">
              <CheckCircle2 size={40} />
            </div>
            <div className="text-center md:text-left">
              <h2 className="text-2xl font-bold text-gray-900 mb-2">Todos os sistemas operacionais</h2>
              <p className="text-gray-500 flex items-center justify-center md:justify-start gap-2">
                <Clock size={16} /> Atualizado agora mesmo
              </p>
            </div>
          </div>

          <div className="pt-8">
             <h3 className="text-xl font-bold mb-6">Serviços da Plataforma</h3>
             <div className="space-y-4">
               {systems.map((sys, idx) => (
                 <div key={idx} className="flex items-center justify-between p-4 bg-slate-50 rounded-2xl">
                   <div className="flex items-center gap-4">
                     <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                     <span className="font-semibold text-gray-800">{sys.name}</span>
                   </div>
                   <div className="text-right">
                     <span className="inline-block px-3 py-1 bg-green-100 text-green-700 text-xs font-bold uppercase rounded-full tracking-wider mb-1">
                       {sys.status}
                     </span>
                     <p className="text-xs text-gray-400 font-medium hidden sm:block mt-1">{sys.time}</p>
                   </div>
                 </div>
               ))}
             </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          <div className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm flex items-start gap-4">
             <div className="w-12 h-12 bg-indigo-50 text-indigo-600 rounded-xl flex items-center justify-center shrink-0">
                <Activity size={24} />
             </div>
             <div>
                <h4 className="font-bold text-gray-900 mb-1">Monitoramento 24/7</h4>
                <p className="text-sm text-gray-500 leading-relaxed">Nossa equipe técnica monitora a performance e segurança da plataforma continuamente.</p>
             </div>
          </div>
          <div className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm flex items-start gap-4">
             <div className="w-12 h-12 bg-indigo-50 text-indigo-600 rounded-xl flex items-center justify-center shrink-0">
                <Shield size={24} />
             </div>
             <div>
                <h4 className="font-bold text-gray-900 mb-1">Segurança de Dados</h4>
                <p className="text-sm text-gray-500 leading-relaxed">Infraestrutura em nuvem segura com backups isolados em tempo real.</p>
             </div>
          </div>
        </div>
      </main>
    </div>
  );
}
